// Типы для работы с картами
// Default map configuration
export const DEFAULT_MAP_CONFIG = {
    center: {
        address: "Москва, Россия",
        latitude: 55.7558,
        longitude: 37.6176,
    },
    zoom: 10,
    minZoom: 2,
    maxZoom: 19,
    attributionControl: true,
    zoomControl: true,
};
// API keys from requirements (these should be moved to environment variables)
export const MAP_API_CONFIG = {
    javascriptApiKey: process.env.GEOCODE_API_KEY || "",
    // routeApiKey: "4b7abbc8-3461-4e72-a91c-3fd3e10e8e11",
    geosuggestApiKey: process.env.GEOSUGGEST_API_KEY || "",
};
// Color constants for routes and locators
export const MAP_COLORS = {
    PRIMARY_ROUTE: "#1890ff",
    ACTUAL_ROUTE: "#fa8c16",
    SECONDARY_ROUTE: "#52c41a",
    WARNING_ROUTE: "#faad14",
    DANGER_ROUTE: "#ff4d4f",
    DEFAULT_LOCATOR: "#1890ff",
    ACTIVE_LOCATOR: "#52c41a",
    SELECTED_LOCATOR: "#faad14",
};
